import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { useResellerList } from '../stores/FetcherStores/resellerFetcher';
import useCompanyId from '../hooks/useCompanyId';
import {
  useGetCompany,
  useUpdateCompanyResellerMutation,
} from '../stores/FetcherStores/CompanyFetcher';

const NO_RESELLER = 'NO_RESELLER';

const ResellerSelect = observer(() => {
  const { t } = useTranslation();
  const companyId = useCompanyId();
  const { data: resellers, isLoading } = useResellerList();
  const { data: company } = useGetCompany(companyId);
  const { mutate: updateCompanyReseller, isLoading: isUpdatingReseller } =
    useUpdateCompanyResellerMutation();

  const choosenReseller = company?.resellerId || NO_RESELLER;

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  if (isUpdatingReseller) {
    return <Typography>Updating reseller...</Typography>;
  }

  if (!resellers) {
    return <Typography>No resellers found</Typography>;
  }

  return (
    <Box sx={{ marginTop: 4 }}>
      <FormControl sx={{ width: '50%' }} fullWidth>
        <InputLabel id="demo-simple-select-label">
          {t('subscriptionScreen.selectReseller')}
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={choosenReseller}
          label={t('subscriptionScreen.selectReseller')}
          onChange={(event) => {
            const resellerId = event.target.value;
            if (resellerId === NO_RESELLER) {
              updateCompanyReseller(companyId, '');
            } else {
              updateCompanyReseller(companyId, resellerId);
            }
          }}
        >
          <MenuItem value={NO_RESELLER} key="NoReseller">
            No reseller
          </MenuItem>
          {resellers.map((reseller) => (
            <MenuItem value={reseller.id} key={reseller.id}>
              {reseller.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
});

export default ResellerSelect;
